import type { NDictionaries } from '@app/types/Dictionaries';

export const COUNTRIES_INITIAL_STATE: {
  dictionary: NDictionaries.ModelCountry[];
} = {
  dictionary: [],
};
